import { ColorEnum } from '@/constants/color'
import Typography from '@/features/ui/typography'
import dayjs from 'dayjs'
import { FC } from 'react'

interface CreatedAtProps {
    createdAt: number
}

const CreatedAt: FC<CreatedAtProps> = ({ createdAt }) => {
    return (
        <Typography.Menu
            size="small"
            style={{ flexShrink: 0, color: ColorEnum.JET_500, textTransform: 'uppercase' }}
        >
            {dayjs.unix(createdAt).format('D. MMM HH:mm')}
        </Typography.Menu>
    )
}

export default CreatedAt
